import { CircularProgress, Collapse, Paper } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroller'

import {
  RateConnectionChannelFieldsType,
  RoomTypeForRateConnection
} from '../../types/rateConnection'
import PriceClassDistributionRatePlanRow from './PriceClassDistributionRatePlanRow'
import PriceClassDistributionRoomtypeRow from './PriceClassDistributionRoomtypeRow'
import useStyles from './styles/PriceClassDistributionRoomtypeBox.styles'

interface PriceClassDistributionRoomtypeBoxProps {
  roomTypeData: RoomTypeForRateConnection
  roomTypeIndex: number
  updatedRateConnectionList: RoomTypeForRateConnection[]
  setUpdatedRateConnectionList: React.Dispatch<
    React.SetStateAction<RoomTypeForRateConnection[]>
  >
  weekendIndexes: number[]
  range: 'TWO_WEEKS' | 'MONTH'
  selectedMenuFieldInChannelRow: RateConnectionChannelFieldsType
  setSelectedMenuFieldInChannelRow: React.Dispatch<
    React.SetStateAction<RateConnectionChannelFieldsType>
  >
}

const PriceClassDistributionRoomtypeBox: React.FC<
  PriceClassDistributionRoomtypeBoxProps
> = ({
  roomTypeData,
  roomTypeIndex,
  updatedRateConnectionList,
  setUpdatedRateConnectionList,
  weekendIndexes,
  range,
  selectedMenuFieldInChannelRow,
  setSelectedMenuFieldInChannelRow
}) => {
  const classes = useStyles()
  const [openAll, setOpenAll] = useState(false)
  const [showRatePlan, setShowRatePlan] = useState(false)
  const PAGE_SIZE = 10
  const [numberOfVisibleRatePlans, setnumberOfVisibleRatePlans] =
    useState(PAGE_SIZE)

  useEffect(() => {
    if (openAll) {
      setShowRatePlan(true)
    } else {
      setShowRatePlan(false)
    }
  }, [openAll])

  useEffect(() => {
    setOpenAll(false)
    setShowRatePlan(false)
  }, [range])

  return (
    <Paper className={classes.paper} elevation={5}>
      <div>
        <PriceClassDistributionRoomtypeRow
          name={`${roomTypeData.name} (${roomTypeData.code})`}
          numberOfRatePlans={roomTypeData.ratePlans.length}
          showRatePlan={showRatePlan}
          setShowRatePlan={setShowRatePlan}
          openAll={openAll}
          setOpenAll={setOpenAll}
          weekendIndexes={weekendIndexes}
          range={range}
        />
        <Collapse in={showRatePlan}>
          <div>
            <InfiniteScroll
              pageStart={0}
              loadMore={() => {
                setTimeout(() => {
                  setnumberOfVisibleRatePlans(
                    numberOfVisibleRatePlans + PAGE_SIZE
                  )
                }, 500)
              }}
              hasMore={
                roomTypeData &&
                numberOfVisibleRatePlans < roomTypeData.ratePlans.length - 1
              }
              loader={
                <div key={0} className={classes.loadingContainer}>
                  <CircularProgress size={32} />
                </div>
              }
              useWindow={true}>
              {roomTypeData.ratePlans
                .slice(0, numberOfVisibleRatePlans)
                .map((item, ratePlanIndex) => (
                  <PriceClassDistributionRatePlanRow
                    key={ratePlanIndex}
                    ratePlanData={item}
                    openAll={openAll}
                    roomTypeIndex={roomTypeIndex}
                    ratePlanIndex={ratePlanIndex}
                    updatedRateConnectionList={updatedRateConnectionList}
                    setUpdatedRateConnectionList={setUpdatedRateConnectionList}
                    weekendIndexes={weekendIndexes}
                    range={range}
                    selectedMenuFieldInChannelRow={
                      selectedMenuFieldInChannelRow
                    }
                    setSelectedMenuFieldInChannelRow={
                      setSelectedMenuFieldInChannelRow
                    }
                  />
                ))}
            </InfiniteScroll>
          </div>
        </Collapse>
      </div>
    </Paper>
  )
}

export default PriceClassDistributionRoomtypeBox
